import React from "react";
import PropTypes from "prop-types";

const MenuInsetDivider = (props, context) => {
  const { style } = props;

  const { baseTheme, prepareStyles } = context.muiTheme;

  const styles = {
    root: {
      margin: 0,
      marginTop: 8,
      marginBottom: 7,
      marginLeft: 64,
      width: 140,
      height: 1,
      border: "none",
      backgroundColor: baseTheme.palette.borderColor
    }
  };

  return <hr style={prepareStyles(Object.assign(styles.root, style))} />;
};

MenuInsetDivider.propTypes = {
  style: PropTypes.object
};

MenuInsetDivider.contextTypes = {
  muiTheme: PropTypes.object.isRequired
};

export default MenuInsetDivider;



// WEBPACK FOOTER //
// ./src/app/components/partials/menu-inset-divider.jsx